import React, { useState, useEffect } from 'react';
import { db, handleFirestoreError, OperationType } from '../../firebase';
import { doc, onSnapshot, collection, addDoc, serverTimestamp, query, orderBy, limit, getDocs, where } from 'firebase/firestore';
import { Heart, Music, ArrowLeft } from 'lucide-react';

interface Track {
  title: string;
  url: string;
}

export default function OnAir({ clientId }: { clientId: string }) {
  const [current, setCurrent] = useState<Track | null>(null);
  const [previous, setPrevious] = useState<Track | null>(null);

  useEffect(() => {
    console.log("DEBUG: OnAir component mounted with clientId:", clientId);
    if (!clientId) return;
    const path = `displays/${clientId}/onAirData/current`;
    const unsub = onSnapshot(doc(db, path), (doc) => {
      if (doc.exists()) {
        const data = doc.data();
        console.log("DEBUG: OnAir data received for path", path, ":", data);
        // The data is stored directly in fields in the document
        setCurrent(data.current || null);
        setPrevious(data.previous || null);
      } else {
        console.log("DEBUG: OnAir document does not exist at path:", path);
      }
    }, (error) => handleFirestoreError(error, OperationType.GET, path));
    return () => unsub();
  }, [clientId]);

  const addFavorite = async (track: Track) => {
    try {
      const q = query(collection(db, 'clientes', clientId, 'favorites'), where("url", "==", track.url));
      const snap = await getDocs(q);
      if (!snap.empty) {
        alert("Esta canción ya está en favoritos.");
        return;
      }
      await addDoc(collection(db, 'clientes', clientId, 'favorites'), {
        ...track,
        addedAt: Date.now()
      });
      alert(`Añadido a favoritos: ${track.title}`);
    } catch (err) {
      alert("Error al añadir a favoritos.");
    }
  };

  const TrackCard = ({ track, label }: { track: Track | null, label: string }) => (
    <div className="bg-white/5 p-4 rounded-xl mb-4 border border-white/10">
      <div className="text-xs text-white/50 mb-2">{label}</div>
      {track ? (
        <div className="space-y-3">
          <div className="flex justify-between items-center">
            <div className="flex items-center gap-3">
              <Music size={20} className="text-yellow-500" />
              <span className="font-medium text-white truncate max-w-[200px]">{track.title}</span>
            </div>
            <button onClick={() => addFavorite(track)} className="text-white/50 hover:text-red-500 transition-colors">
              <Heart size={20} />
            </button>
          </div>
          {label === "SONANDO AHORA" && track.url && (
            <audio src={track.url} controls className="w-full h-8 opacity-80" />
          )}
        </div>
      ) : (
        <div className="text-white/20 italic">No hay información</div>
      )}
    </div>
  );

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold text-white mb-6">ON AIR</h2>
      <TrackCard track={current} label="SONANDO AHORA" />
      <TrackCard track={previous} label="ANTERIOR" />
    </div>
  );
}
